import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4ddb0a53"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "col-12 mb-4 [ JS_shipment_select JS_shipment_scrollTo ]" };
const _hoisted_2 = {
    id: "RedShippingOptionSelectionBox",
    class: "col-12 bg-white border rounded pt-3"
};
const _hoisted_3 = { class: "row border-bottom" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "font7 mb-2" }, "Schritt 3 von 3")
], -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-7 pr-0" }, [
    /*#__PURE__*/ _createElementVNode("h2", { class: "h5 mb-3" }, "Deine Versandart")
], -1));
const _hoisted_6 = { class: "col-5 text-right pl-0" };
const _hoisted_7 = {
    key: 0,
    class: "font7 p-1 bg-brand_green_neon rounded"
};
const _hoisted_8 = {
    key: 1,
    class: "font7 p-1 fc-darkRed",
    style: { "background": "rgba(113, 74, 74, 0.1)" }
};
const _hoisted_9 = { class: "col-7 pr-0 custom-control custom-radio" };
const _hoisted_10 = {
    for: "shipSelfSent",
    class: "col-5 text-right"
};
const _hoisted_11 = {
    key: 0,
    src: "/images/_new_brand/logo_dhl.svg",
    alt: "DHL",
    title: "DHL",
    style: { "max-width": "72px", "height": "auto", "max-height": "30px", "object-fit": "contain" }
};
const _hoisted_12 = {
    key: 1,
    class: "border rounded d-inline-block",
    style: { "background": "#fff", "padding": "2px 5px" }
};
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon-brand_user" }, null, -1));
const _hoisted_14 = [
    _hoisted_13
];
const _hoisted_15 = { class: "row border-bottom pb-1" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "col-12 font7 mb-3",
    style: {}
}, [
    /*#__PURE__*/ _createTextVNode(" Du bringst dein Paket selbst zum nächsten Paketshop. "),
    /*#__PURE__*/ _createElementVNode("span", { class: "d-inline-block" }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "icon-brand_search fc-gray1" }),
        /*#__PURE__*/ _createElementVNode("a", {
            title: "Paketshop Finder der Post",
            target: "_blank",
            href: "https://www.deutschepost.de/de/s/standorte.html?standorttyp=packstationen_paketboxen&pmtype=4",
            class: "link-gray"
        }, " Paketshop Finder ")
    ]),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createElementVNode("div", { class: "mt-2" }, [
        /*#__PURE__*/ _createTextVNode(" Nach Abschluss des Auftrags erhältst Du von uns ein "),
        /*#__PURE__*/ _createElementVNode("strong", null, "Versandetikett"),
        /*#__PURE__*/ _createTextVNode(" . ")
    ])
], -1));
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = { class: "row py-3 pl-4" };
const _hoisted_19 = { class: "col-7 pr-0 custom-control custom-radio" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "shipPickup",
    class: "col-5 pl-0 text-right"
}, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: "/images/_new_brand/logo_abholung.svg",
        alt: "DHL",
        style: { "max-width": "72px", "height": "auto", "max-height": "30px", "object-fit": "contain" }
    })
], -1));
const _hoisted_21 = { class: "row" };
const _hoisted_22 = { class: "col-12" };
const _hoisted_23 = { class: "col-12 m-0 p-0" };
const _hoisted_24 = { class: "col-12 font7 mb-4" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/icons/LKW-Icon.svg",
    title: "Abholung",
    alt: "LKW",
    width: "16",
    height: "16",
    style: { "margin-right": "6px" }
}, null, -1));
const _hoisted_27 = {
    key: 0,
    class: "row mt-n3 no-pickup-info"
};
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-12 font7 mb-4" }, [
    /*#__PURE__*/ _createElementVNode("div", {
        class: "font7 p-1",
        style: { "background": "rgba(113, 74, 74, 0.1)", "color": "rgb(144, 17, 17)", "display": "inline-block" }
    }, " Der Abholservice ist erst ab einem Verkaufspreis von 100 € möglich. ")
], -1));
const _hoisted_29 = [
    _hoisted_28
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_radio_input = _resolveComponent("radio-input");
    const _component_date_input = _resolveComponent("date-input");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                    (_ctx.free_shipping)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Kostenlos"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, " Kostenpflichtig "))
                ])
            ]),
            _createElementVNode("div", {
                class: _normalizeClass(["row pt-3 pb-1 pl-4 mb-0", { 'border-bottom': _ctx.shipping_option == 'pickup' || _ctx.shipping_option == null }])
            }, [
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_radio_input, {
                        id: "shipSelfSent",
                        label: "Beim Paket-Shop abgeben",
                        value: "self-sent",
                        name: "versandart",
                        checked: _ctx.shipping_options === 'self-sent',
                        disabled: !_ctx.self_send_available,
                        onChange: _ctx.changeShippingToSelfSend,
                        "tracking-class": "track_red_shipping_self"
                    }, null, 8, ["checked", "disabled", "onChange"])
                ]),
                _createElementVNode("label", _hoisted_10, [
                    (_ctx.free_shipping)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                ])
            ], 2),
            _createVNode(_Transition, null, {
                default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", _hoisted_15, _hoisted_17, 512), [
                        [_vShow, _ctx.shipping_option == 'self-sent']
                    ])
                ]),
                _: 1
            }),
            _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_radio_input, {
                        id: "shipPickup",
                        label: "Kostenloser Abholservice",
                        value: "pickup",
                        name: "versandart",
                        checked: _ctx.shipping_option === 'pickup',
                        "tracking-class": "track_red_shipping_pickup",
                        disabled: !_ctx.pickup_available,
                        onChange: _ctx.changeShippingToPickup
                    }, null, 8, ["checked", "disabled", "onChange"])
                ]),
                _hoisted_20
            ]),
            _createVNode(_Transition, null, {
                default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                                (_ctx.cart)
                                    ? (_openBlock(), _createBlock(_component_date_input, {
                                        key: 0,
                                        label: "Abholdatum",
                                        "onUpdate:modelValue": [
                                            _ctx.savePickupDate,
                                            _cache[0] || (_cache[0] = ($event) => ((_ctx.pickup_date) = $event))
                                        ],
                                        "allowed-dates": _ctx.pickupDates,
                                        "start-date": _ctx.pickupDates.at(1),
                                        modelValue: _ctx.pickup_date,
                                        valid: _ctx.pickup_date !== null,
                                        "show-adjacent-months": true
                                    }, null, 8, ["onUpdate:modelValue", "allowed-dates", "start-date", "modelValue", "valid"]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                            _createTextVNode(" Du willst aktuell lieber nicht vor die Tür? Nutze einfach den Abholservice. "),
                            _hoisted_25,
                            _createElementVNode("div", null, [
                                _hoisted_26,
                                _createElementVNode("p", {
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.renderModalAbholserviceDetails && _ctx.renderModalAbholserviceDetails(...args))),
                                    class: "link-in-text d-inline-block",
                                    title: "Abholservice Informationen"
                                }, " Abholservice Details ")
                            ])
                        ])
                    ], 512), [
                        [_vShow, _ctx.shipping_option === 'pickup' && _ctx.pickup_available]
                    ])
                ]),
                _: 1
            }),
            (!_ctx.pickup_available)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                : _createCommentVNode("", true)
        ])
    ]));
}
